import { Grid } from '@material-ui/core';

import Announcements from './Announcements';
import AppLinks from './AppLinks';

const Dashboard = () => (
  <Grid container direction="row" spacing={2} id="Dashboard">
    <Grid item xs={12} md={8} lg={9}>
      <Announcements />
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <AppLinks />
    </Grid>
  </Grid>
);

export default Dashboard;
